// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2VKIX","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__yBTVL"};